// snippet::snippet-systembase3[TS]
import { ComponentListenerImpl } from './ComponentListenerImpl';
import { SystemBase2 } from './SystemBase2';
import type { Component, Entity } from '@inter-ikea-core/core';

/**
 * A type of system listening to three components
 * When implementing a system like this, do consider if you are really separating concerns properly or
 * it should really be separate systems
 * Sometimes there is a need for a system listening to different components though, and in that case this
 * class can be inherited to reduce a lot of the boilerplate code
 *
 * Note that in order for the system to work it must be registered with the EntityManager
 */
export abstract class SystemBase3<TComponent1 extends Component, TComponent2 extends Component, TComponent3 extends Component> extends SystemBase2<
  TComponent1,
  TComponent2
> {
  constructor(component1Id: number, component2Id: number, component3Id: number) {
    super(component1Id, component2Id);

    this.onAddComponent3 = this.onAddComponent3.bind(this);
    this.onUpdateComponent3 = this.onUpdateComponent3.bind(this);
    this.onRemoveComponent3 = this.onRemoveComponent3.bind(this);
    this._componentListeners.push(
      new ComponentListenerImpl(this, component3Id, this.onAddComponent3, this.onUpdateComponent3, this.onRemoveComponent3)
    );
  }

  protected abstract onAddComponent3(entity: Entity, newComponent: TComponent3): void;
  protected abstract onUpdateComponent3(entity: Entity, oldComponent: TComponent3, newComponent: TComponent3): void;
  protected abstract onRemoveComponent3(entity: Entity, oldComponent: TComponent3): void;
}
// end::snippet-systembase3
